import React, { useMemo, useState } from "react";

import { FormTypeEnum, SentContact } from "@layout/modals/types";

import AuthorizationFormContext from "@/contexts/AuthorizationForm/AuthorizationFormContext";

import { AuthorizationFormContextProps } from "./types";

const AuthorizationFormContextProvider = ({ children }: AuthorizationFormContextProps) => {
  const [isShown, setIsShown] = useState<boolean | undefined>(undefined);

  const [formType, setFormType] = useState<FormTypeEnum | null>(null);
  const [sentContact, setSentContact] = useState<SentContact | null>(null);
  const [backButtonFormType, setBackButtonFormType] = useState<FormTypeEnum>(FormTypeEnum.Login);
  const [formCloseCallback, setFormCloseCallback] = useState<(() => void) | null>(null);
  const [sentCodeTimestamp, setSentCodeTimestamp] = useState<number | null>(null);

  const AuthorizationFormContextValue = useMemo(
    () =>
      ({
        backButtonFormType,
        formCloseCallback,
        formType,
        isShown,
        sentCodeTimestamp,
        sentContact,
        setBackButtonFormType,
        setFormCloseCallback,
        setFormType,
        setIsShown,
        setSentCodeTimestamp,
        setSentContact,
      }),
    [backButtonFormType, formCloseCallback, formType, isShown, sentCodeTimestamp, sentContact],
  );

  return (
    <AuthorizationFormContext.Provider
      value={AuthorizationFormContextValue}
    >
      {children}
    </AuthorizationFormContext.Provider>
  );
};

export default AuthorizationFormContextProvider;
